export default __webpack_public_path__ + "static/media/past-medical-history-fundamental-icon.bd9a81da.svg";